import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import {
  Input,
  InputText,
  FormGroup,
  FormControl,
  FormControlText,
  InputCheckBox,
  Divider,
  InputDateTimev2
} from '@itandi/itandi-bb-ui';
import { SingleComboBox } from '@itandi/itandi-bb-ui/SingleComboBox';
import { Controller, useFormContext } from 'react-hook-form';
import type { ComponentProps } from 'react';
import { useCallback } from 'react';
import type { DealTodoEdit } from '~/models/DealTodo';
import { toDate } from '~/utils/DateUtil';
import type { Staff } from '~/models/Staff';
import type { CompanyDealTodo } from '~/models/CompanyDealTodo';
import type { Deal } from '~/models/Deal';

type Props = DeepReadonly<{
  deal: Deal | CompanyDealTodo['deal'];
  staffs: Staff[];
}>;

export const DealClientTodoModalForm: React.FC<Props> = ({
  deal,
  staffs
}: Props) => {
  const {
    setValue,
    register,
    watch,
    control,
    formState: { errors }
  } = useFormContext<DealTodoEdit>();
  const onChangeStaff: NonNullable<
    ComponentProps<typeof SingleComboBox>['onChange']
  > = useCallback(
    (option) => {
      if (!option) {
        setValue('staff', null);
      } else {
        setValue(
          'staff',
          staffs.find((staff) => staff.id === Number(option.value)) ?? null
        );
      }
    },
    [setValue, staffs]
  );
  const assignedStaff = watch('staff');
  return (
    <FormGroup variant="horizontal">
      <FormControl label="完了">
        <InputCheckBox
          {...register('completed')}
          checked={watch('completed')}
          label="TODOを完了にする"
        />
      </FormControl>
      <Divider />
      <FormControl
        chip="必須"
        isInvalid={errors.title != null}
        label="タイトル"
      >
        <Input {...register('title')} />
        <FormControlText error={errors.title?.message} />
      </FormControl>
      <Divider />
      <FormControl label="担当者">
        <SingleComboBox
          defaultValue={
            assignedStaff !== null
              ? { value: String(assignedStaff.id), label: assignedStaff.name }
              : { value: String(deal.staff.id), label: deal.staff.name }
          }
          maxMenuHeight={200}
          onChange={onChangeStaff}
          options={staffs.map((staff) => ({
            value: String(staff.id),
            label: `${staff.name}`
          }))}
          placeholder="選択してください"
        />
      </FormControl>
      <Divider />
      <FormControl label="対応期限">
        <Controller
          control={control}
          name="dueDate"
          render={({ field: { value, onChange } }) => (
            <InputDateTimev2
              onChange={(date): void => {
                onChange(date?.toISOString() ?? null);
              }}
              value={toDate(value)}
            />
          )}
        />
      </FormControl>
      <Divider />
      <FormControl label="メモ">
        <InputText rows={3} {...register('memo')} />
      </FormControl>
    </FormGroup>
  );
};
